import {IAppInfoResponse} from '../../interfaces/services';

import {Platform} from 'react-native';

export const extractRemoteVersion = (
  payload: IAppInfoResponse['payload'],
): string => {
  if (Platform.OS === 'ios') {
    return payload.version.ios;
  }
  if (Platform.OS === 'android') {
    return payload.version.android;
  }
  return '0.0.0';
};
